<template>
  <div style="position: relative;">
    <el-container>
      <el-header height="64px">
        <div style="display: flex">
          <span class="title">变现管理平台</span>
        </div>
        <div class="dark-switcher">
          <el-switch style="margin: 16px" v-model="dark" @change="changeDark"
                     active-action-icon="Moon" inactive-action-icon="Sunny"></el-switch>
          <span style="margin-right: 12px; color: var(--el-text-color-regular);">{{ $root.user.name }}</span>
          <!-- TEMP — delete after first cloud admin exists -->
          <el-button
            v-if="showBootstrapAdmin"
            size="small"
            type="warning"
            :loading="bootstrapLoading"
            @click="bootstrapAdmin()"
          >设为管理员</el-button>
          <el-button size="small" type="text" @click="logout()">退出登录</el-button>
        </div>
      </el-header>
      <el-container :style="{height: height + 'px'}" class="app-body-container">
        <aside-nav ref="nav">
          <aside-group title="平台">
            <aside-item icon="Connection" title="中介组" index="MediationGroups"></aside-item>
          </aside-group>
          <aside-group v-if="$root.user.role === 'admin'" title="系统管理">
            <aside-item icon="User" title="用户管理" index="UserManage"></aside-item>
          </aside-group>
        </aside-nav>
        <el-main class="app-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import {useDark, useToggle} from '@vueuse/core'
import AsideNav from "./base/AsideNav";
import AsideItem from "./base/AsideItem";
import AsideGroup from "./base/AsideGroup";
import axios from "ts-axios-new";
import {load_shared_data} from './libs/sharedData';
import {ElMessage} from 'element-plus';
import {showHttpError} from './libs/errorDisplay';

const BOOTSTRAP_ADMIN_EMAIL = 'ruijie.liu@bidderdesk.com';

export default {
  name: 'App',
  components: {AsideGroup, AsideItem, AsideNav},
  data() {
    return {
      height: document.documentElement.clientHeight - 64,
      width: document.documentElement.clientWidth,
      dark: window.matchMedia('(prefers-color-scheme: dark)').matches,
      user: {
        avatar: '',
        name: '',
        email: '',
        role: 'user',
      },
      user_options: [],
      cdn_url: import.meta.env.VITE_CDN_URL,
      handleResize: null,
      system_dark_media: null,
      handle_system_dark_change: null,
      bootstrapLoading: false,
    }
  },
  computed: {
    // TEMP — delete with bootstrap button after first cloud admin exists
    showBootstrapAdmin() {
      const email = String(this.$root.user.email || '').trim().toLowerCase();
      return email === BOOTSTRAP_ADMIN_EMAIL && this.$root.user.role !== 'admin';
    },
  },
  methods: {
    changeDark() {
      useToggle(useDark())(this.dark);
    },
    handleScroll() {
      this.height = document.documentElement.clientHeight - 64;
      this.width = document.documentElement.clientWidth;
    },
    logout() {
      axios.get(`/cms/v1/logout`).then(_ => {
        location.reload();
      })
    },
    // TEMP — calls /cms/v1/bootstrap-admin (= set_user_role on the server's Mongo)
    bootstrapAdmin() {
      this.bootstrapLoading = true;
      axios.post('/cms/v1/bootstrap-admin').then(res => {
        Object.assign(this.$root.user, res.data.data);
        ElMessage.success('已设为管理员');
      }).catch((err) => {
        showHttpError(err, '设为管理员失败');
      }).finally(() => {
        this.bootstrapLoading = false;
      });
    },
  },
  mounted() {
    this.handleResize = _ => {
      this.handleScroll();
    };
    window.addEventListener('resize', this.handleResize);
    this.changeDark();
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    this.system_dark_media = media;
    this.handle_system_dark_change = e => {
      this.dark = e.matches;
      this.changeDark();
    };
    media.addEventListener('change', this.handle_system_dark_change);
    load_shared_data(this);
  },
  beforeUnmount() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    if (this.system_dark_media && this.handle_system_dark_change) {
      this.system_dark_media.removeEventListener('change', this.handle_system_dark_change);
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
}

.el-header {
  display: flex;
  padding: 0 20px;
  justify-content: space-between;
  border-bottom: solid 1px var(--el-border-color-light);
  background-color: var(--el-bg-color);
}
</style>
<style scoped>
.title {
  line-height: 64px;
  font-size: 20px;
  color: var(--el-text-color-regular);
}

.dark-switcher {
  display: flex;
  align-items: center;
}

.dark-switcher ::v-deep(.el-switch__action) {
  color: #000 !important;
}
.dark-switcher ::v-deep(.el-switch.is-checked .el-switch__core) {
  background-color: #444;
  border-color: #444;
}

.app-body-container {
  background-color: var(--el-border-color-extra-light);
}

.el-aside {
  background-color: var(--el-border-color-extra-light);
  color: var(--el-text-color-secondary);
}
.app-main {
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
  padding: 0;
  min-height: 0;
}

.app-main > * {
  flex: 1 0 auto;
  min-height: 0;
}
</style>
<style>
html.dark .app-body-container {
  background-color: var(--el-bg-color-page);
}

html.dark .el-aside {
  background-color: var(--el-bg-color);
  border-right: 1px solid var(--el-border-color-light);
}
</style>
